// 引入模块
import axios from "axios";
// import config from "../config"
import router from "../router/index";
// axios初始化：延迟时间，主路由地址
let instance = axios.create({
  baseURL:
    process.env.NODE_ENV == "development"
      ? "http://localhost:62010/wechat/"
      : "https://stock.shuolei-it.com/wechat/",
  headers: { "Content-Type": "application/json" },
  timeout: 60000
});

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 在发送请求之前做某事

    // 在请求头中加入token
    if (localStorage.getItem("a-token")) {
      config.headers["a-token"] = localStorage.getItem("a-token");
    }
    if (localStorage.getItem("s-token")) {
      config.headers["s-token"] = localStorage.getItem("s-token");
    }

    return config;
  },
  error => {
    // 请求错误时做些事

    return Promise.reject(error);
  }
);

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 对响应数据做些事

    // loadingInstance.close();

    return response;
  },
  error => {
    // 请求错误时做些事

    return Promise.reject(error);
  }
);

// 请求成功的回调
function checkStatus(res) {
  // 请求结束成功
  if (res.status === 200 || res.status === 304) {
    if (res.data.status === "401-s") {
      // Message.error(res.data.message)
      localStorage.setItem("s-token", "");
      router.push("/login");
      return false;
    } else if (res.data.status === "401-a") {
      // Message.error(res.data.message)
      localStorage.setItem("a-token", "");
      router.push("/authorize");
      return false;
    }
    // 对token进行处理
    if (res.data.tokenObj != null) {
      let tokenObj = JSON.parse(res.data.tokenObj);
      localStorage.setItem(tokenObj.type, tokenObj.token);
    }
    return res.data;
  } else {
    console.error("其它状态码", res);
  }
}

// 模块化导出
export default {
  post(url, data) {
    if (!url) return;
    return instance({
      method: "post",
      url: url,
      data: JSON.stringify(data)
    })
      .then(checkStatus)
      .catch(error => {
        // 请求失败
        console.error("请求失败", error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/utils/axiosUtil.js